import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import VuePwaInstallPlugin from "vue-pwa-install";
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import "@pwabuilder/pwainstall";
import VueYandexMetrika from 'vue-yandex-metrika'   


Vue.use(VueYandexMetrika, {
  id: 74863414,
  router: router,
  env: process.env.NODE_ENV,

})



Vue.use(VueTheMask)
Vue.use(Vuelidate)
Vue.component('v-select', vSelect)
Vue.use(VuePwaInstallPlugin);
Vue.use(Autocomplete)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

